<div class="filter-for-list">
  <h3 class="alarm-project-name">WIMD+D</h3>
  <br clear="both"/>
  <div class="wimd-filters">
    <div class="event-dyn-filters">
      <div class="date-fields">

        <div (click)="reset()" class="reset-button">
          <img id="resetFilterButton" src="../../../../assets/images/wimd/reload.png">
        </div>

        <mat-form-field mat-form-field>
          <input matInput [matDatepicker]="startDatePicker" [formControl]="datePickerControl.controls.startDate"
                 [placeholder]="'FROM' | translate">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
        <div style="padding-left: 10px">
          <ngb-timepicker [(ngModel)]="startTime" (ngModelChange)="setTime($event, 'start')"
                          [meridian]="false"></ngb-timepicker>
        </div>

        <mat-form-field mat-form-field>
          <input matInput [matDatepicker]="endDatePicker" [formControl]="datePickerControl.controls.endDate"
                 [placeholder]="'TO' | translate">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
        <div style="padding-left: 10px">
          <ngb-timepicker [(ngModel)]="endTime" (ngModelChange)="setTime($event, 'end')"
                          [meridian]="false"></ngb-timepicker>
        </div>


        <span (click)="getPassages()" class="valid-button">
        <svg xml:space="preserve" viewBox="0 0 100 100.60000000000001">
            <polygon style=""
                     points="37.316,80.48 0,43.164 17.798,25.366 37.316,44.885 82.202,0 100,17.798 37.316,80.48 "/>
        </svg>
      </span>

        <mat-form-field mat-ripple="false">
          <mat-select class="filterStyle" [ngModel]="confidence || ALL" [placeholder]="'CONFIDENCE'|translate">
            <mat-option (click)="updateQueryFilter(CONFIDENCE,null)" [value]="ALL">{{'ALL' | translate }}</mat-option>
            <mat-option (click)="updateQueryFilter(CONFIDENCE,d)" *ngFor="let d of confidenceList"
                        [value]="d">{{d}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="divider">|</div>

        <mat-form-field mat-ripple="false">
          <mat-select class="filterStyle" [ngModel]="direction || ALL" [placeholder]="'DIRECTION'|translate">
            <mat-option (click)="updateQueryFilter(DIRECTION,null)" [value]="ALL">{{'ALL' | translate}}</mat-option>
            <mat-option (click)="updateQueryFilter(DIRECTION,d)" *ngFor="let d of directionsList"
                        [value]="d">{{d}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="divider">|</div>

        <mat-form-field mat-ripple="false" *ngIf="filters">
          <mat-select class="filterStyle" [ngModel]="category || ALL" [placeholder]="'CATEGORY'|translate">
            <mat-option (click)="updateQueryFilter(CATEGORY,null)" [value]="ALL">{{'ALL' | translate}}</mat-option>
            <mat-option (click)="updateQueryFilter(CATEGORY,d)" *ngFor="let d of filters?.thresholds; let i = index;"
                        [value]="d">{{getCategoryForQuery(i)}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="divider">|</div>
        <span class="pickerLabels">{{"THRESHOLD"|translate}} (t) </span>
        <div class="threshold">
          <input matInput [(ngModel)]="filters?.thresholds[0]" placeholder="Threshold 1">
          <input matInput [(ngModel)]="filters?.thresholds[1]" placeholder="Threshold 1">
          <input matInput [(ngModel)]="filters?.thresholds[2]" placeholder="Threshold 2">
        </div>
        <span (click)="applyFilters()" class="valid-button-threshold">
        <svg xml:space="preserve" viewBox="0 0 100 100.60000000000001">
            <polygon style=""
                     points="37.316,80.48 0,43.164 17.798,25.366 37.316,44.885 82.202,0 100,17.798 37.316,80.48 "/>
        </svg>
      </span>

      </div>
    </div>
  </div>
  <button type="button" (click)="getCSV()" class="btn top-list-tools">{{"EXPORT"|translate}}
  </button>
  <app-project-sub-menu></app-project-sub-menu>

  <br clear="both"/> <br clear="both"/>
</div>
<app-progressbar *ngIf="wimdStore.isLoading "></app-progressbar>
<app-wimd-chart></app-wimd-chart>
<app-wimd-table></app-wimd-table>
